import { observer, useLocalObservable } from "mobx-react"
import { Flex, Form, Typography } from "antd"

import { notify } from "@src/app/components/notify"
import { WhiteListCollection } from "@src/app/whitelistStore/WhiteListCollection"
import { WhiteList } from "@src/pages/settingsWhitelist/classes/WhiteList"
import { WhiteListForm } from "@src/pages/settingsWhitelist/ui/WhiteListForm"
import { WhiteListTable } from "@src/pages/settingsWhitelist/ui/WhiteListTable"
import {
  WhiteListIpCreate,
  WhiteLIstIpsCollection,
} from "@src/pages/settingsWhiteListIp/classes/WhiteLIstIpsCollection"
import { WhiteListIPForm } from "@src/pages/settingsWhiteListIp/ui/WhiteListIPForm"
import { WhiteListIPTable } from "@src/pages/settingsWhiteListIp/ui/WhiteListIPTable"
import { InlineObject17 } from "@src/shared/api/generated"
import { useCatchFormErrors } from "@src/shared/form/base_error"

export const SettingsWhiteListIpPage = observer(() => {
  const [form] = Form.useForm()

  const { submit } = useCatchFormErrors(
    form,
    async (data: WhiteListIpCreate) => {
      return collection.create(data).then((res) => {
        if (res) {
          form.resetFields()
          notify.success("Address has been added")
        }
      })
    },
  )

  const collection = useLocalObservable(() => new WhiteLIstIpsCollection())

  return (
    <Flex gap={32} vertical>
      <Typography.Text style={{ fontSize: 16 }}>
        Restrict read and write requests through API keys to specified IPv4
        addresses
      </Typography.Text>
      <WhiteListIPForm
        form={form}
        isLoading={collection.isLoading}
        submit={submit}
      ></WhiteListIPForm>

      {(!collection.isEmpty || collection.isLoading) && (
        <WhiteListIPTable
          collection={collection}
          deleteFn={collection.delete}
        />
      )}
    </Flex>
  )
})
